import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  agreement: '',
  enableFee: false,
  feePrice: 0,
  isRoundClosed: false,
  lastRoundDate: '',
  liveScan: '',
  lotteryPrice: 0,
  nextRound: '',
  popupImage: '',
  roundDate: '',
  showResult: false,
  soldoutImage: '',
  topNews: '',
  userActive: 0,
}

const reducers = {
  setWebConfig: (state, action) => {
    return action.payload
  },
}

export const webConfigSlice = createSlice({
  name: 'webConfig',
  initialState,
  reducers,
})
export const { setWebConfig } = webConfigSlice.actions
export default webConfigSlice.reducer
